var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pallet-teaser" }, [
    _c(
      "div",
      { staticClass: "row justify-center relative-position" },
      [
        _vm.teaserImage
          ? _c("q-img", {
              staticClass: "col-12 col-md-auto log-teaser-image",
              staticStyle: { width: "100%" },
              attrs: {
                src: _vm.teaserImage,
                alt: _vm.palletNo,
                position: "50% 100%",
                ratio: "2.666666666666667",
                contain: ""
              }
            })
          : _c(
              "q-img",
              {
                staticClass: "col-12 col-md-auto log-teaser-image",
                staticStyle: { width: "100%" },
                attrs: {
                  src: _vm.fallbackImagePath,
                  alt: _vm.palletNo,
                  ratio: "2.666666666666667"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "absolute-full text-subtitle2 flex flex-center"
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("previewImageUnavailable")) +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "q-px-md" }, [
      _c("h5", [_vm._v(_vm._s(_vm.name))]),
      _vm._v(" "),
      _c("span", { staticClass: "subheading" }, [
        _vm._v(_vm._s(_vm.speciesName))
      ]),
      _vm._v(" "),
      _vm.unavailable
        ? _c("p", { staticClass: "text-secondary" }, [
            _vm._v(_vm._s(_vm.$t("palletUnavailable.short")))
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }